/* eslint-disable no-nested-ternary */
import { Add, Delete } from '@mui/icons-material';
import { Box, IconButton, TextFieldProps } from '@mui/material';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import PrimaryButton from '../PrimaryButton';
import FormTextField from './FormTextField';

type FormType = Record<string, { value: string }[]>;

export type Props = Omit<TextFieldProps, 'name'> & {
  name: string;
  addButtonLabel: string;
};

const FormArrayField = ({ name, addButtonLabel, ...props }: Props) => {
  const { control } = useFormContext<FormType>();

  const { fields, append, remove } = useFieldArray({
    control,
    name,
    keyName: 'id',
  });

  return (
    <Box>
      {fields.map(({ id }, index) => (
        <Box key={id} sx={{ display: 'flex', gap: 1, my: 1 }}>
          <FormTextField color="secondary" fullWidth size="small" name={`${name}.${index}.value`} {...props} />
          <IconButton disabled={props.disabled} onClick={() => remove(index)}>
            <Delete />
          </IconButton>
        </Box>
      ))}

      <Box sx={{ maxWidth: 260 }}>
        <PrimaryButton
          disabled={props.disabled}
          startIcon={<Add />}
          color="secondary"
          onClick={() => append({ value: '' })}
        >
          {addButtonLabel}
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default FormArrayField;
